import { render, staticRenderFns } from "./TeamMiniCard.vue?vue&type=template&id=633cc4e2&scoped=true&"
import script from "./TeamMiniCard.vue?vue&type=script&lang=ts&"
export * from "./TeamMiniCard.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMiniCard.vue?vue&type=style&index=0&id=633cc4e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633cc4e2",
  null
  
)

export default component.exports